'use strict';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.pipeline.targetSelect.directive', [
  ])
  .directive('targetSelect', function() {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        model: '='
      },
      templateUrl: require('./targetSelect.html'),
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/targetSelect.directive.js